import React, { useRef, useState } from 'react'
import UploadIcon from '../Icons/UploadIcon'
import { getFileName } from '../../utils/formatter'

const FileInput = ({
  label,
  labelTopRight,
  labelBottomLeft,
  labelBottomRight,
  name,
  placeholder = 'Upload File',
  required,
  maxFileSize = 5242880,
  allowedFileType = ['image/png', 'image/jpg', 'image/jpeg', 'application/pdf'],
}) => {
  const inputRef = useRef()
  const [fileName, setFileName] = useState('')

  const onChange = (event) => {
    let file = null
    if (event.target.files && event.target.files.length === 1) {
      file = event.target.files[0]
    }
    if (file === null) {
      return
    }
    if (file.size > maxFileSize) {
      inputRef.current.value = null
      alert('File terlalu besar')
      return
    }
    if (!allowedFileType.includes(file.type)) {
      inputRef.current.value = null
      alert('Tipe file salah')
      return
    }
    setFileName(getFileName(event.target.value))
  }

  return (
    <div className="form-control w-full max-w-lg">
      <label className="label">
        <span className="label-text text-[#838489]">{label}</span>
        <span className="label-text-alt">{labelTopRight}</span>
      </label>
      <div
        className="bg-[#FEF7F4] p-4 flex justify-between items-center"
        onClick={() => inputRef.current.click()}
      >
        <div className="text-[#F56632]">
          {fileName === '' ? placeholder : fileName}
        </div>
        <UploadIcon />
      </div>
      <input
        type="file"
        name={name}
        aria-label={label}
        className="hidden"
        ref={inputRef}
        required={required}
        onChange={(e) => {
          onChange(e)
        }}
      />
      <label className="label">
        <span className="label-text-alt text-[#838489]">{labelBottomLeft}</span>
        <span className="label-text-alt">{labelBottomRight}</span>
      </label>
    </div>
  )
}

export default FileInput
